import style from "./style.scss";
import { mergeClasses } from "../helpers";

const SmallViewOnly = ({ class: className = null, children, ...props }) => {
  const mergedClass = mergeClasses([style.smallViewOnly, className]);

  return (
    <div class={mergedClass} {...props}>
      {children}
    </div>
  );
};

export default SmallViewOnly;
